import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { HeaderWrapper } from './style';
import logo from "../../images/credu_loan_logo.png";
import logoSm from '../../images/credu_loan_logo.png';
import bar from '../../images/bar.png';
import userIcon from '../../images/userIcon.webp';
import ContextDashboard from '../../Context/ContextDashboard';
import { getDashboardData } from '../../Utils/api';
import { getStorage, isEmpty } from '../../Utils/common';
import Footer from "../../images/footer_bg_2.jpg";
import user from '../../images/userreviews.svg'
import SideBar from '../Sidebar/SideBar';
import { MdOutlineMailOutline } from "react-icons/md";
import { MdCall } from "react-icons/md";

function DashboardHeader({ toggle, setToggle }) {
  const [dashboard, setDashboard] = useState([]);
  const { message, setMessage, setProfileData, profileData, setSetps, getProfileDaital } = useContext(ContextDashboard);
  const navigate = useNavigate(); 

  useEffect(() => {
    const params = {
      profile_id: getStorage("cust_profile_id") || "",
    };

    getDashboardData(params).then(resp => {
      if (resp?.data?.Status === 1) {
        // Set dashboard data
        const dashboardData = resp?.data || {};
        setDashboard(dashboardData);
      }
    });
  }, []);

  // Handle right flex box click
  const handleRightFlexClick = () => {
    const eligibility = getStorage('eligibility');
    if (eligibility === 1) {
      navigate('/my-dashboard/lead-preview'); 
    } else {
      navigate('/my-dashboard/profile-preview'); 
    }
  };

  return (
    <HeaderWrapper
      style={{
        // backgroundImage: `url(${Footer})`,
        // backgroundSize: 'cover',
       
       borderBottom:'1px solid #ddd'
      }}
      className='flex justify-between'
    >
      <div className="left flex">
        <div className="badgeIcon pointer" onClick={() => setToggle(!toggle)}>
          <img style={{ width: "32px" }} src={bar} alt="logo" />
        </div>
         <div className="logo">
          <Link to="/">
            <img className='xl' src={logo} alt="logo" />
          </Link>
    
        </div> 

        {/* <SideBar/> */}

        <div style={{background:'', padding:'2px 10px'}}>
           <MdOutlineMailOutline style={{color:'#198754', fontSize:'30px'}}/> &nbsp; <span style={{fontSize:'19px', fontWeight:'500', color:'#000'}}>info@credumoney.com </span>
         
        </div>

        <div style={{background:'', padding:'2px 20px'}}>
          <MdCall style={{color:'#198754', fontSize:'30px'}}/> <span style={{fontSize:'19px', fontWeight:'500', color:'#000'}}> +81:00000-00000 </span>
         
        </div>

          {}

        
       
      </div>

      <div className="right flex" onClick={handleRightFlexClick} style={{cursor:'pointer'}}>
        <div className="icon">
          <img src={dashboard?.Data?.profile_pic || getStorage("selfie")} alt="" />
        </div>
        <div className="name" > Hi, {getStorage("fullName") || dashboard?.Data?.profile_details?.first_name}</div>
      </div>
    </HeaderWrapper>
  );
}

export default DashboardHeader;
